import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { JobDescription } = await import('./index');
    return {
        Component: JobDescription,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
